import { fg } from '@atlaskit/platform-feature-flags/fg';
import { type AgentCreatorType } from '@atlaskit/rovo-agent-components/common/types';
import { type ChatStorePrivateState } from '@atlassian/conversation-assistant-store/controllers/chat/types';

import { getConversation } from './getConversation';
import { shouldPreprocessDetailsForCreatorType } from './shouldPreprocessDetailsForCreatorType';

/**
 * Whether to rewrite HTML `<details>` / `<summary>` blocks into the Rovo-native
 * expand boundary before markdown rendering, for the agent on this conversation.
 *
 * See `shouldPreprocessDetailsForCreatorType` for how an absent creator type is
 * treated and why.
 */
export const shouldPreprocessDetailsForConversation = (
	state: ChatStorePrivateState,
	conversationId: string,
): boolean => {
	const creatorType = getConversation(state, conversationId)?.agent?.creator_type;
	if (creatorType === 'ROVO_DEV') {
		return fg('rovo_chat_jca_details_expands') && fg('jira_ai_rendering_a2ui');
	}
	return shouldPreprocessDetailsForCreatorType(creatorType as AgentCreatorType | undefined);
};
